// extracted by mini-css-extract-plugin
export default {"section":"PageSection__section___20h5S","depth-1":"PageSection__depth-1___3uhzG","inner":"PageSection__inner___3sS-H"};